import React, { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { Redirect } from "react-router-dom";
import config from "../config";
import AccountOpenWait from "../components/account-open-wait";
import AnnualIncome from "../components/annual-income";
import LiquidAssets from "../components/liquid-assets";
import Citizenship from "../components/citizenship";
import Kyc3 from "../components/kyc-3";
import Kyc2 from "../components/kyc-2";
import RiskQuestionnaire from "../components/risk-questionnaire";
import RiskRecommendation from "../components/risk-recommendation";
import AccountFundingSource from "../components/account-funding-source";
import Login from "../components/login";
// import Otp from "../components/otp";
import Name from "../components/name";
import Dob from "../components/dob";
import Disclosures from "../components/disclosures";
import KycFail from "../components/kyc-fail";
import FundingFail from "../components/funding-fail";
import Address from "../components/address";
import Ssn from "../components/ssn";
import BankingInfo from "../components/banking-info";
import EmailAddress from "../components/email-address";
import BuyWait from "../components/buy-wait";
import BuySuccess from "../components/buy-success";
import ShowHoldings from "../components/show-holdings";
import AccountOpenSuccess from "../components/account-open-success";
import Loading from "../components/loading";
import PrivateRoute from "../components/private-route";
import NetworkError from "../components/network-error";

const Router = () => {
  return (
    <div style={{ height: "100%", maxWidth: "100vw" }}>
      {/* public routes */}
      <Route exact path={config.routes.loading} component={Loading} />
      <Switch>
        <Route exact path={config.routes.login} component={Login} />
        <PrivateRoute exact path={config.routes.name} component={Name} />
        <PrivateRoute
          exact
          path={config.routes.email}
          component={EmailAddress}
        />
        <PrivateRoute exact path={config.routes.dob} component={Dob} />
        <PrivateRoute path={config.routes.address} component={Address} />
        <PrivateRoute
          path={config.routes.annualIncome}
          component={AnnualIncome}
        />
        <PrivateRoute
          path={config.routes.liquidAssets}
          component={LiquidAssets}
        />
        <PrivateRoute
          path={config.routes.citizenship}
          component={Citizenship}
        />
        <PrivateRoute path={config.routes.ssn} component={Ssn} />
        <PrivateRoute path={config.routes.kyc3} component={Kyc3} />
        <PrivateRoute path={config.routes.kyc2} component={Kyc2} />
        <PrivateRoute
          path={config.routes.riskQuestionnaire}
          component={RiskQuestionnaire}
        />
        <PrivateRoute
          path={config.routes.riskRecommendation}
          component={RiskRecommendation}
        />
        <PrivateRoute
          path={config.routes.accountFundingSource}
          component={AccountFundingSource}
        />
        <PrivateRoute
          path={config.routes.bankinginfo}
          component={BankingInfo}
        />
        <PrivateRoute
          path={config.routes.disclosures}
          component={Disclosures}
        />
        <PrivateRoute
          path={config.routes.accountOpenWait}
          component={AccountOpenWait}
        />
        <PrivateRoute path={config.routes.kycFail} component={KycFail} />
        <PrivateRoute
          path={config.routes.accountOpenSuccess}
          component={AccountOpenSuccess}
        />
        <PrivateRoute path={config.routes.buyWait} component={BuyWait} />
        <PrivateRoute path={config.routes.buySuccess} component={BuySuccess} />
        <PrivateRoute
          path={config.routes.fundingFail}
          component={FundingFail}
        />
        <PrivateRoute
          path={config.routes.showHoldings}
          component={ShowHoldings}
        />
        <PrivateRoute
          path={config.routes.networkError}
          component={NetworkError}
        />
      </Switch>
    </div>
  );
};

export default Router;
